import { render } from "./Header.vue?vue&type=template&id=0f18850f&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=0f18850f&scoped=true&lang=scss"

import exportComponent from "/Users/gabrielvoissiere/Documents/Developpement/Developpement prs/npm package/simply_wave_demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f18850f"]])

export default __exports__